// extracted by mini-css-extract-plugin
export default {"form":"Input_form__ZlAlp"};